const Header = () => {
  return <div></div>;
};

export default Header;
